'use strict';

class ReportList {
  constructor(userService, originatorService, reportService, Notification) {
    this.userService = userService;
    this.originatorService = originatorService;
    this.reportService = reportService;
    this.Notification = Notification;
  }

  $onInit() {
    this.isVisma = false;
    this.originator = {};
    this.params = {
      email: null,
      copyEmail: null,
      reportFormat: 'XLS',
      reports: [
        'invoices',
        'recipients',
        'accountOverview'
      ],
      from: moment().subtract(1, 'year').startOf('year').format('DD.MM.YY'),
      to: moment().endOf('year').format('DD.MM.YY')
    };

    this.reports = {
      invoices: true,
      recipients: true,
      accountOverview: true,
      'revenue/overview': false,
      'revenue/balance': false,
      openItems: false,
      payments: false,
      currency: false
    };

    this.i18n = {
      invoices: 'Fakturajournal',
      recipients: 'Kundeliste',
      accountOverview: 'Kontoutskrift',
      'revenue/overview': 'Omsetning per produkt',
      'revenue/balance': 'Saldoliste',
      openItems: 'Åpne poster',
      payments: 'Innbetalinger',
      currency: 'Valutagevinst'
    };

    this.loadUser();
    this.loadOriginator();
  }

  loadUser() {
    this.userService.get()
      .then((resp) => {
        this.isVisma = true;
      });
  }

  loadOriginator() {
    this.originatorService.get()
      .then((resp) => {
        this.originator = resp.data;
        this.params.email = resp.data.contact.email;
      });

    this.originatorService.settings()
      .then((resp) => {
        this.params.copyEmail = resp.data.defaults.copy.email;
      });
  }

  toggle(report) {
    let index = this.params.reports.indexOf(report);

    if (index !== -1) {
      this.reports[report] = false;
      this.params.reports.splice(index, 1);
    } else {
      this.reports[report] = true;
      this.params.reports.push(report);
    }
  }

  generateMessage(arr) {
    let sent = '';
    let sentItems = [];
    let notSent = '';
    let notSentItems = [];

    this.params.reports.forEach((i) => {
      if (arr.indexOf(i) !== -1) {
        sentItems.push(this.i18n[i]);
      } else {
        notSentItems.push(this.i18n[i]);
      }
    }, this);

    if (sentItems.length) {
      sent = 'Følgende rapporter er sendt:<br>';

      sentItems.forEach((item) => {
        sent += `<strong>- ${item}</strong><br>`;
      });
    }

    if (notSentItems.length) {
      notSent = 'Følgende rapporter kunne dessverre ikke sendes:<br>';

      notSentItems.forEach((item) => {
        notSent += `- ${item}<br>`;
      });
    }

    return sent + notSent;
  }

  sendEmail() {
    $('button.submit').prop('disabled', true);
    let clone = angular.copy(this.params);

    if (clone.copyEmail === '') {
      clone.copyEmail = null;
    }

    // fix dates
    clone.from = moment(this.params.from, 'DD.MM.YY').format('YYYY-MM-DD');
    clone.to = moment(this.params.to, 'DD.MM.YY').format('YYYY-MM-DD');

    this.reportService.sendEmail(clone)
      .then((resp) => {
        this.Notification.info(this.generateMessage(resp.data));
        $('button.submit').prop('disabled', false);
      })
      .catch(() => {
        $('button.submit').prop('disabled', false);
      });
  }
}

ReportList.$inject = ['userService', 'originatorService', 'reportService', 'Notification'];

const reportList = {
  controller: ReportList,
  template: `
    <h2>Rapporter</h2>

    <div class="row">
      <div class="large-6 columns">
        <ul class="no-bullet">
          <li><a href="#/rapport/fakturajournal">Regninger / Fakturajournal</a></li>
          <li><a href="#/rapport/pdf">Eksporter regninger til PDF-fil</a></li>
          <li><a href="#/rapport/omsetning">Omsetning</a></li>
          <li ng-if="$ctrl.originator.bankAccount.kid"><a href="#/rapport/betaling">Innbetalingsrapport</a></li>
          <li><a href="#/rapport/produkt">Innbetalinger per produkt</li>
          <li><a href="#/rapport/tilbud">Tilbud</a></li>
          <li><a href="#/rapport/ordrebekreftelse">Ordrebekreftelser</a></li>
          <li><a href="#/rapport/valuta">Valutagevinst/-tap</a></li>
          <li><a href="#/rapport/saldo">Saldoliste</a></li>
          <!-- <li ng-if="$ctrl.isVisma"><a href="#/rapport/visma">Vismaeksport</a></li> -->
        </ul>
      </div>

      <div class="large-6 columns">
        <ul class="no-bullet">
          <li><a href="#/rapport/kontoutskrift">Regninger fra SendRegning</a></li>
        </ul>
      </div>
    </div>

    <form name="reportEmailForm" ng-cloak ng-submit="$ctrl.sendEmail()">
      <h3 class="subheader">Send til regnskapsfører</h3>

      <fieldset>
        <div>
          <label for="email">E-postadresse</label>
          <input type="email" id="email" name="email" autocomplete="email" ng-model="$ctrl.params.email" maxlength="64" placeholder="ola@nordmann.no" required>
        </div>

        <div>
          <label for="copyEmail">Send kopi til</label>
          <input type="email" id="copyEmail" name="copyEmail" ng-model="$ctrl.params.copyEmail" maxlength="64" placeholder="ola@nordmann.no">
        </div>
      </fieldset>

      <p><a href ng-click="$ctrl.toggleEmailExtra = !$ctrl.toggleEmailExtra">Velg hva som skal sendes</a></p>

      <fieldset ng-show="$ctrl.toggleEmailExtra">
        <h3 class="subheader">Hva skal sendes</h3>

        <div>
          <label for="invoices">
            <input type="checkbox" id="invoices" name="invoices" ng-model="$ctrl.reports.invoices" ng-change="$ctrl.toggle('invoices')"> Fakturajournal (liste over regninger)
          </label>
          <label for="recipients">
            <input type="checkbox" id="recipients" name="recipients" ng-model="$ctrl.reports.recipients" ng-change="$ctrl.toggle('recipients')"> Kundeliste
          </label>
          <label for="accountOverview">
            <input type="checkbox" id="accountOverview" name="accountOverview" ng-model="$ctrl.reports.accountOverview" ng-change="$ctrl.toggle('accountOverview')"> Kontoutskrift for bruk av SendRegning
          </label>
          <label for="revenueOverview">
            <input type="checkbox" id="revenueOverview" name="revenueOverview" ng-model="$ctrl.reports['revenue/overview']" ng-change="$ctrl.toggle('revenue/overview')"> Omsetning per produkt
          </label>
          <label for="revenueBalance">
            <input type="checkbox" id="revenueBalance" name="revenueBalance" ng-model="$ctrl.reports['recipients/balance']" ng-change="$ctrl.toggle('recipients/balance')"> Saldoliste fra siste dagen i valgt periode
          </label>
          <label for="openItems">
            <input type="checkbox" id="openItems" name="openItems" ng-model="$ctrl.reports.openItems" ng-change="$ctrl.toggle('openItems')"> Åpne poster
          </label>
          <label for="payments" ng-show="$ctrl.originator.bankAccount.kid">
            <input type="checkbox" id="payments" name="payments" ng-model="$ctrl.reports.payments" ng-change="$ctrl.toggle('payments')"> Innbetalinger
          </label>
          <label for="currency">
            <input type="checkbox" id="currency" name="currency" ng-model="$ctrl.reports.currency" ng-change="$ctrl.toggle('currency')"> Valutagevinst
          </label>
        </div>

      </fieldset>

      <div ng-show="$ctrl.toggleEmailExtra">
        <report-generator ng-model="$ctrl.params" default="custom" />
      </div>

      <div class="row">
        <div class="large-6 columns">
          <label for="reportFormat">Velg format</label>
          <select id="reportFormat" name="reportFormat" ng-model="$ctrl.params.reportFormat">
            <option value="XLS" ng-selected="$ctrl.params.reportFormat === 'XLS'">XLS</option>
            <option value="CSV" ng-selected="$ctrl.params.reportFormat === 'CSV'">CSV</option>
          </select>
        </div>
      </div>

      <button type="submit" class="button submit" ng-disabled="reportEmailForm.$invalid">Send</button>
    </form>
  `
};

angular
  .module('SendRegning')
  .component('reportList', reportList)
  .config(($routeProvider) => {
    $routeProvider
      .when('/rapport', {
        title: 'Rapporter',
        template: '<report-list />',
        secure: true
      });
  });
